import { TrendDownIcon, TrendUpIcon } from '../../../../components/icons';
import { TrendInfoIcon } from '../../../../components/icons/TrendInforIcon';
import { useTreasurySummary } from '../../../../customhooks/treasury/useTreasurySummary';
import CashPositionCard from '../TransactionsDetails/Components/CashPositionCard';
import CreditDebitRatioCard from '../TransactionsDetails/Components/CreditDebitRatioCard';
import TotalBalanceCard from '../TransactionsDetails/Components/TotalBalanceCard';

const TreasuryOverviewSummary = () => {
    const { summaryDetails } = useTreasurySummary();

    const summaryList = [
        {
            label: 'Total consolidated balance',
            amount: summaryDetails?.total ?? 0,
            trend: 'positive',
            percent: 0,
            currency: 'NGN',
            logo: (
                <div className='w-[32px] h-[32px] flex justify-center items-center rounded-[50%] bg-[#F2F4F7]'>
                    <TrendInfoIcon />
                </div>
            ),
            message: 'Combined balance across all your linked accounts.'
        },
        {
            label: 'Total Opening Balance',
            amount: summaryDetails?.opening ?? 0,
            trend: 'negative',
            percent: 0,
            currency: 'NGN',
            logo: (
                <div className='w-[32px] h-[32px] flex justify-center items-center rounded-[50%] bg-[#ECFDF3]'>
                    <TrendDownIcon />
                </div>
            ),
            message: 'Your consolidated balance at the start of the day'
        },
        {
            label: 'Total Closing Balance',
            amount: summaryDetails?.closing ?? 0,
            trend: 'positive',
            percent: 0,
            currency: 'NGN',
            logo: (
                <div className='w-[32px] h-[32px] flex justify-center items-center rounded-[50%] bg-provincialPink'>
                    <TrendUpIcon />
                </div>
            ),
            message: 'Your consolidated balance at the end of the day'
        }
    ];

    return (
        <>
            <div className='hidden lg:flex gap-4 mt-4'>
                <TotalBalanceCard />
                <CashPositionCard />
                <CreditDebitRatioCard />
            </div>
        </>
    );
};

export default TreasuryOverviewSummary;
